module.exports = __webpack_public_path__ + "img/minus-disabled.0ea57030.svg";